const clickableElements = document.querySelectorAll('.ShopCategoriesMenuMobile .clickable');

clickableElements?.forEach((el) => {
    el.addEventListener('click', (e) => {
        e.preventDefault();

        const parent = e.target?.parentNode;
        const ul = parent?.querySelector(':scope > ul');
        ul?.classList.toggle('active');
    });
});
